import React, { useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const MuiPopOver = ({
  anchorEl,
  open,
  onClose,
  children,
  className = "",
  transform,
}) => {
  const popoverRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!anchorEl) return;
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        anchorEl &&
        !anchorEl.contains(event.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl, onClose]);

  if (!open || !anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const styles = {
    top: rect.bottom + window.scrollY - rect.height - 10,
    left: rect.left + window.scrollX + rect.width / 2,
    transform: transform || "translate(-50%, -100%)",
  };

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        top: styles.top,
        left: styles.left,
        transform: styles.transform,
      }}
      className={`mui-list-pop-up ${className}`}
    >
      {children}
    </div>,
    document.body
  );
};

export default MuiPopOver;
